import React from 'react';
import { withLocalize } from "react-localize-redux";
import Header from '../header';
import { withRouter } from 'react-router';

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.lang = 'en';

    }

    showResults(s) {
        this.props.history.push({
            pathname: '/Search',
            state: { searchResults: s }
        })
    }

    render() {

        if (this.props.activeLanguage)
        this.lang = this.props.activeLanguage.code;
        
        var imgPng = `${process.env.PUBLIC_URL}/DataModeler.png?v=1.045`;

        if (this.lang === 'en')
            imgPng = `${process.env.PUBLIC_URL}/DataModeler_EN.png?v=1.045`;

        return (
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">

                    <Header showResults={this.showResults.bind(this)} />
                    <div className="container-fluid">
                        <img style={{ marginTop: 0 }} src={imgPng} width='100%' />
                    </div>
                </div>
            </div>

        );
    }
}

export default withRouter(withLocalize(Home));